<template>
    <div>
         <!-- HEADER TITULO -->
        <div class="titulo-contenido">
            <h1>
                <span class="negrita">PAGO DE CONTRIBUCIONES</span>
            </h1>
        </div>
        <!-- CONTENIDO PRINCIPAL -->
        <div class="container contenido_principal">
        <!-- <h1 class="subtitulo mb-0">Contenido en construcción</h1> -->
            <!-- ===Apartado de las cards=== -->
        <div class="seccion_cardsOpciones my-5">
            <div class="row px-5 d-flex align-items-center justify-content-between">
            <div class="col-xs-12 col-sm-4 col-md-4">
                <a target="_blank" :href="'http://www.ingresos.'+urlSubdominio+'CIE/Acesso.asp?opcion=9' ">
                    <div class="card mb-3 p-1" >
                        <div class="row no-gutters">
                        <!---Imagen de la card-->
                        <div class="col-md-4 p-2 text-center justify-content-center" >
                            <i class="fas fa-file-invoice-dollar icono_card"></i>
                        </div>
                        <!---Texto de la card-->
                        <div class=" col-md-8">
                            <div class="card-body">
                            <h5 class="card-title mb-4">Nóminas</h5>
                            </div>
                        </div>
                        </div>
                    </div>
                    </a>
            </div>
            <div class="col-xs-12 col-sm-4 col-md-4">
                <a target="_blank" :href="'http://www.ingresos.'+urlSubdominio+'CIE/Acesso.asp?opcion=1' ">
                    <div class="card mb-3 p-1" id="seleccionado">
                        <div class="row no-gutters">
                            <div class="col-md-4 p-2 text-center justify-content-center">
                            <i class="fas fa-hotel icono_card"></i>
                            </div>
                            <div class="col-md-8">
                            <div class="card-body">
                                <h5 class="card-title mb-4">Hospedaje</h5>
                            </div>
                            </div>
                        </div>
                        </div>
                    </a>
            </div>
            <div class="col-xs-12 col-sm-4 col-md-4">
                <a target="_blank" :href="'http://www.ingresos.'+urlSubdominio+'CIE/BA/AccesoBebidas.asp'">
                    <div class="card mb-3 p-1" id="seleccionado">
                        <div class="row no-gutters">
                            <div class="col-md-4 p-2 text-center justify-content-center">
                            <i class="fas fa-wine-glass-alt icono_card"></i>
                            </div>
                            <div class="col-md-8">
                            <div class="card-body">
                                <h5 class="card-title mb-4">Bebidas Alcohólicas</h5>
                            </div>
                            </div>
                        </div>
                        </div>
                    </a>
            </div>
            </div>
            <div class="row px-5 d-flex align-items-stretch justify-content-between">
            <div class="col-xs-12 col-sm-4 col-md-4">
                <a target="_blank" :href="'http://www.ingresos.'+urlSubdominio+'CIE/Acesso.asp?opcion=27'">
                    <div class="card mb-3 p-1" >
                        <div class="row no-gutters">
                        <!---Imagen de la card-->
                        <div class="col-md-4 p-2 text-center justify-content-center" >
                            <!-- <img src="imagenes/img1.jpg" alt=""> -->
                            <i class="fas fa-book icono_card"></i>
                        </div>
                        <!---Texto de la card-->
                        <div class=" col-md-8">
                            <div class="card-body">
                            <h5 class="card-title mb-4">Establecimientos Mutuantes</h5>
                            </div>
                        </div>
                        </div>
                    </div>
                    </a>
            </div>
            <div class="col-xs-12 col-sm-4 col-md-4">
                <a target="_blank" :href="'http://www.ingresos.'+urlSubdominio+'CIE/Acesso.asp?opcion=24'">
                    <div class="card mb-3 p-1" id="seleccionado">
                        <div class="row no-gutters">
                            <div class="col-md-4 p-2 text-center justify-content-center">
                            <i class="fab fa-unsplash icono_card"></i>
                            </div>
                            <div class="col-md-8">
                            <div class="card-body">
                                <h5 class="card-title mb-4" style="font-size:.8rem;">Juegos Permitidos, Rifas, Sorteos, Loterías y Concursos</h5>
                            </div>
                            </div>
                        </div>
                        </div>
                    </a>
            </div>
            <div class="col-xs-12 col-sm-4 col-md-4">
                <a target="_blank" :href="'http://www.ingresos.'+urlSubdominio+'CIE/Acesso.asp?opcion=30'">
                    <div class="card mb-3 p-1" id="seleccionado">
                        <div class="row no-gutters">
                            <div class="col-md-4 p-2 text-center justify-content-center">
                            <i class="fas fa-gamepad icono_card"></i>
                            </div>
                            <div class="col-md-8">
                            <div class="card-body">
                                <h5 class="card-title mb-4">Erogaciones en Juegos con Apuestas</h5>
                            </div>
                            </div>
                        </div>
                        </div>
                    </a>
            </div>

            </div>
            <div class="row px-5 d-flex align-items-center justify-content-between">
            
                <div class="col-xs-12 col-sm-4 col-md-4">
                <a target="_blank" :href="'http://www.ingresos.'+urlSubdominio+'CIE/Acesso.asp?opcion=10' ">
                    <div class="card mb-3 p-1" >
                        <div class="row no-gutters">
                        <!---Imagen de la card-->
                        <div class="col-md-4 p-2 text-center justify-content-center" >
                            <!-- <img src="imagenes/img1.jpg" alt=""> -->
                           <i class="fas fa-file-alt icono_card"></i>
                        </div>
                        <!---Texto de la card-->
                        <div class=" col-md-8">
                            <div class="card-body">
                            <h5 class="card-title mb-4">Consulta de Constancias de Retención</h5>
                            </div>
                        </div>
                        </div>
                    </div>
                    </a>
            </div>
            <div class="col-xs-12 col-sm-4 col-md-4">
                <a target="_blank" :href="'http://www.ingresos.'+urlSubdominio+'CIE/Acesso.asp?opcion=29' ">
                    <div class="card mb-3 p-1" id="seleccionado">
                        <div class="row no-gutters">
                            <div class="col-md-4 p-2 text-center justify-content-center">
                            <i class="fas fa-car-side icono_card"></i>
                            </div>
                            <div class="col-md-8">
                            <div class="card-body">
                                <h5 class="card-title mb-4">Consulta Declaración Anual ISAN - Impuesto S/Automóviles Nvos.</h5>
                            </div>
                            </div>
                        </div>
                    </div>
                </a>
            </div>

            <div class="col-xs-12 col-sm-4 col-md-4">
                <a target="_blank" :href="'http://www.ingresos.'+urlSubdominio+'CIE/Acesso.asp?opcion=16' ">
                    <div class="card mb-3 p-1" id="seleccionado">
                        <div class="row no-gutters">
                            <div class="col-md-4 p-2 text-center justify-content-center">
                            <i class="fas fa-money-check-alt icono_card"></i>
                            </div>
                            <div class="col-md-8">
                            <div class="card-body">
                                <h5 class="card-title mb-4">Captura de declaracion Anual </h5>
                            </div>
                            </div>
                        </div>
                        </div>
                    </a>
            </div>

            </div>
            <div class="row px-5 d-flex align-items-center justify-content-between">
            <div class="col-xs-12 col-sm-4 col-md-4">
                <a target="_blank" :href="'http://www.ingresos.'+urlSubdominio+'CIE/Acesso.asp?opcion=17'">
                    <div class="card mb-3 p-1" >
                        <div class="row no-gutters">
                        <!---Imagen de la card-->
                        <div class="col-md-4 p-2 text-center justify-content-center" >
                            <!-- <img src="imagenes/img1.jpg" alt=""> -->
                            <i class="fas fa-search-dollar icono_card"></i>
                        </div>
                        <!---Texto de la card-->
                        <div class=" col-md-8">
                            <div class="card-body">
                            <h5 class="card-title mb-4">Consultas de Declaracion Anual</h5>
                            </div>
                        </div>
                        </div>
                    </div>
                    </a>
            </div>
            <div class="col-xs-12 col-sm-4 col-md-4">
                <a target="_blank" :href="'http://www.ingresos.'+urlSubdominio+'CIE/Acesso.asp?opcion=21' ">
                    <div class="card mb-3 p-1" id="seleccionado">
                        <div class="row no-gutters">
                            <div class="col-md-4 p-2 text-center justify-content-center">
                            <i class="fas fa-file-alt icono_card"></i>
                            </div>
                            <div class="col-md-8">
                            <div class="card-body">
                                <h5 class="card-title mb-4">Anexos</h5>
                            </div>
                            </div>
                        </div>
                        </div>
                    </a>
            </div>
            <div class="col-xs-12 col-sm-4 col-md-4">
                <a target="_blank" :href="'http://www.ingresos.'+urlSubdominio+'CIE/Acesso.asp?opcion=25' ">
                    <div class="card mb-3 p-1" id="seleccionado">
                        <div class="row no-gutters">
                            <div class="col-md-4 p-2 text-center justify-content-center">
                            <i class="fas fa-car icono_card"></i>
                            </div>
                            <div class="col-md-8">
                            <div class="card-body">
                                <h5 class="card-title mb-4">Impuesto S/Automóviles Nuevos</h5>
                            </div>
                            </div>
                        </div>
                        </div>
                    </a>
            </div>

            </div>
            <div class="row px-5 d-flex align-items-center justify-content-between">
            <div class="col-xs-12 col-sm-4 col-md-4">
                <a target="_blank" :href="'http://www.ingresos.'+urlSubdominio+'CIE/Acesso.asp?opcion=7'">
                    <div class="card mb-3 p-1" >
                        <div class="row no-gutters">
                        <!---Imagen de la card-->
                        <div class="col-md-4 p-2 text-center justify-content-center" >
                            <i class="fas fa-comments-dollar icono_card"></i>
                        </div>
                        <!---Texto de la card-->
                        <div class=" col-md-8">
                            <div class="card-body">
                            <h5 class="card-title mb-4">Enajenación de Bienes Inmuebles </h5>
                            </div>
                        </div>
                        </div>
                    </div>
                    </a>
            </div>
            <div class="col-xs-12 col-sm-4 col-md-4">
                <a target="_blank" :href="'http://www.ingresos.'+urlSubdominio+'CIE/Acesso.asp?opcion=28'">
                    <div class="card mb-3 p-1" id="seleccionado">
                        <div class="row no-gutters">
                            <div class="col-md-4 p-2 text-center justify-content-center">
                            <i class="fas fa-truck-pickup icono_card"></i>
                            </div>
                            <div class="col-md-8">
                            <div class="card-body">
                                <h5 class="card-title mb-4">Captura de Declaración Anual ISAN - Impuesto S/Automóviles Nvos. </h5>
                            </div>
                            </div>
                        </div>
                    </div>
                </a>
            </div>
            <div class="col-xs-12 col-sm-4 col-md-4">
                <a target="_blank" :href="'http://www.ingresos.'+urlSubdominio+'CIE/Acesso.asp?opcion=20'">
                    <div class="card mb-3 p-1" id="seleccionado">
                        <div class="row no-gutters">
                            <div class="col-md-4 p-2 text-center justify-content-center">
                            <!-- <i class="fas fa-file-alt icono_card"></i> -->
                            <i class="fas fa-gas-pump icono_card"></i>
                            </div>
                            <div class="col-md-8">
                            <div class="card-body">
                                <h5 class="card-title mb-4">IEPS Gasolina y Diesel</h5>
                            </div>
                            </div>
                        </div>
                        </div>
                    </a>
            </div>

            </div>
            <div class="row px-5 d-flex align-items-center justify-content-start">

            <div class="col-xs-12 col-sm-4 col-md-4">
                <a target="_blank" :href="'http://www.ingresos.'+urlSubdominio+'CIE/Acesso.asp?opcion=11' ">
                    <div class="card mb-3 p-1" id="seleccionado">
                        <div class="row no-gutters">
                            <div class="col-md-4 p-2 text-center justify-content-center">
                            <i class="fas fa-file-invoice icono_card"></i>
                            </div>
                            <div class="col-md-8">
                            <div class="card-body">
                                <h5 class="card-title mb-4" style="font-size:.8rem;">Consulta e Impresión de comprobantes de pago y formularios fiscales</h5>
                            </div>
                            </div>
                        </div>
                    </div>
                </a>
                
            </div>
            <div class="col-xs-12 col-sm-4 col-md-4">
                <a target="_blank" :href="'https://soluciones.'+urlSubdominio+'Predial_Pub/'">
                    <div class="card mb-3 p-1" id="seleccionado">
                        <div class="row no-gutters">
                            <div class="col-md-4 p-2 text-center justify-content-center">
                            <i class="fas fa-donate icono_card"></i>
                            </div>
                            <div class="col-md-8">
                            <div class="card-body">
                                <h5 class="card-title mb-4">Impuesto Predial</h5>
                            </div>
                            </div>
                        </div>
                        </div>
                    </a>
            </div>
            <div class="col-xs-12 col-sm-4 col-md-4">
                <a target="_blank" :href="'http://www.ingresos.'+urlSubdominio+'CIE/Acesso.asp?opcion=40'">
                    <div class="card mb-3 p-1" id="seleccionado">
                        <div class="row no-gutters">
                            <div class="col-md-4 p-2 text-center justify-content-center">
                            <i class="fas fa-industry icono_card"></i>
                            </div>
                            <div class="col-md-8">
                            <div class="card-body">
                                <h5 class="card-title mb-4">Contaminación en Extracción Materiales Petreos</h5>
                            </div>
                            </div>
                        </div>
                        </div>
                    </a>
            </div>
            </div>
            <div class="row px-5 d-flex align-items-center justify-content-start">

            <div class="col-xs-12 col-sm-4 col-md-4">
                <a target="_blank" :href="'http://www.ingresos.'+urlSubdominio+'CIE/Acesso.asp?opcion=50' ">
                    <div class="card mb-3 p-1" id="seleccionado">
                        <div class="row no-gutters">
                            <div class="col-md-4 p-2 text-center justify-content-center">
                            <i class="fas fa-flask icono_card"></i>
                            </div>
                            <div class="col-md-8">
                            <div class="card-body">
                                <h5 class="card-title mb-4" style="font-size:.8rem;">Emisión Contaminantes Suelo/Subsuelo/Agua</h5>
                            </div>
                            </div>
                        </div>
                    </div>
                </a>
                
            </div>
            <div class="col-xs-12 col-sm-4 col-md-4">
                <a target="_blank" :href="'http://www.ingresos.'+urlSubdominio+'CIE/Acesso.asp?opcion=60'">
                    <div class="card mb-3 p-1" id="seleccionado">
                        <div class="row no-gutters">
                            <div class="col-md-4 p-2 text-center justify-content-center">
                            <i class="fas fa-trash-alt icono_card"></i>
                            </div>
                            <div class="col-md-8">
                            <div class="card-body">
                                <h5 class="card-title mb-4">Almacenamiento de Residuos</h5>
                            </div>
                            </div>
                        </div>
                        </div>
                    </a>
            </div>
            
            </div>
            <!-- <div class="row px-5 d-flex align-items-center justify-content-start">
            <div class="col-xs-12 col-sm-4 col-md-4">

            </div>

            </div> -->
            <!-- LEYENDA -->
            <h1 class="subtitulo2 text-muted mt-0"> Los enlaces serán redirigidos al portal de ingresos. </h1>

        </div>

        </div>
    </div>
</template>

<script>

export default({
        mounted(){
        window.scrollTo(0, 0);
    },
})
</script>


<style scoped>

.card-body h5{
    font-size: 1rem;
}

.subtitulo {
    font-weight: 400 !important;
    font-size: 1.8rem !important;
    margin-top: 1.5rem !important;
    text-align: center;
}
.subtitulo2 {
    font-weight: 400 !important;
    font-size: 1.4rem !important;
    /* margin-top: 1rem !important; */
    text-align: center;
}
.card-title{
    font-weight: 400;
}
/* .text-leyendaSH h4 {
    font-size: .9rem !important;
    font-weight: 400 !important;
    line-height: 20px !important;
    font-style: italic;
    text-align: center;
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
} */

a:hover {
    color: black;
    text-decoration: none;
}


</style>
